// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "avada-page-faqs-" + chunkId + "." + {"580": "f56309a757006b7a","717": "0d9fc1e6d15f3b2f","795": "a581decfff9dfac6","821": "d5414a39c0a2ba91",}[chunkId] + ".bundle.js"
}